import type { VolWorkspaceDocument } from "../modules/curves/workspace/volWorkstationTypes";
import { encodeCurveIdForPath } from "../modules/curves/workspace/volWorkstationTypes";

const BASE = "/api/v1/user/curve-workspaces";

function authHeaders(token: string | null): HeadersInit {
  const h: Record<string, string> = { "Content-Type": "application/json" };
  if (token) h.Authorization = `Bearer ${token}`;
  return h;
}

export async function loadCurveWorkspaceRemote(
  curveId: string,
  token: string | null,
): Promise<VolWorkspaceDocument | null> {
  const r = await fetch(`${BASE}/${encodeCurveIdForPath(curveId)}`, {
    headers: authHeaders(token),
    credentials: "omit",
  });
  if (r.status === 204) return null;
  if (!r.ok) throw new Error(`load curve workspace: ${r.status}`);
  return (await r.json()) as VolWorkspaceDocument;
}

export async function saveCurveWorkspaceRemote(
  curveId: string,
  token: string | null,
  doc: VolWorkspaceDocument,
): Promise<VolWorkspaceDocument> {
  const r = await fetch(`${BASE}/${encodeCurveIdForPath(curveId)}`, {
    method: "PUT",
    headers: authHeaders(token),
    credentials: "omit",
    body: JSON.stringify(doc),
  });
  if (!r.ok) throw new Error(`save curve workspace: ${r.status}`);
  return (await r.json()) as VolWorkspaceDocument;
}

export async function deleteCurveWorkspaceRemote(
  curveId: string,
  token: string | null,
): Promise<void> {
  const r = await fetch(`${BASE}/${encodeCurveIdForPath(curveId)}`, {
    method: "DELETE",
    headers: authHeaders(token),
    credentials: "omit",
  });
  if (!r.ok && r.status !== 404) throw new Error(`delete curve workspace: ${r.status}`);
}
